import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Common } from '../../../components';
import PhoneDone from '../../../assets/images/thank-you-cat.png';
import { actionTracking } from '../../../store/common/actions';
import { clearCompletedQuickCashApplication } from '../flowState';

function Complete() {
  const dispatch = useDispatch();
  const location = useLocation();
  const [countDown, setCountDown] = useState(15);

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(actionTracking({
      url: window.location.href,
      product_code: 'quick-cash-20000',
    }));
    // 완료 화면 진입 시 재신청으로 오인되지 않도록 Quick Cash draft를 종료한다.
    clearCompletedQuickCashApplication();

    let count = 15;
    const timer = window.setInterval(() => {
      count -= 1;
      setCountDown(count);
      if (count <= 0) {
        window.clearInterval(timer);
        window.location.href = process.env.REACT_APP_HOME_URL || '/';
      }
    }, 1000);
    return () => window.clearInterval(timer);
  }, [dispatch]);

  const goHome = () => {
    clearCompletedQuickCashApplication();
    window.location.href = process.env.REACT_APP_HOME_URL || '/';
  };

  return (
    <div className="bg-white p-5">
      <Common.StepBar active={4} />
      <p className="flex-1 text-2xl text-primary2 text-right font-semibold border-b border-gray2 mb-4 pb-4">申請完成</p>
      <div className="flex justify-center"><img className="w-1/2 lg:w-auto" src={PhoneDone} alt="" /></div>
      <p className="text-2xl text-primary mb-4 text-center">貸款申請成功</p>
      {location.state?.content?.request_id && (
        <div className="py-3 bg-primary2 text-white text-center text-xl my-4">
          <p>{location.state.content.request_id}</p>
        </div>
      )}
      <p className="text-gray">貸款申請已完成。我們的貸款專員會於辦公時間內盡快聯絡閣下，請留意 2366 8859 的來電。</p>
      <div className="flex justify-center mt-9 mb-4">
        <button type="button" className="rounded-full text-white text-xl bg-primary px-14 py-3" onClick={goHome}>返回主頁 <span>( {countDown} )</span></button>
      </div>
    </div>
  );
}

export default Complete;
